import { Box } from '@mui/material';
import { useSelector } from 'react-redux';
import { FieldSpecialistSelector } from './FieldSpecialistSelector';
import { SamplingGoalWidget } from './SamplingGoalWidget';
import { selectors } from '../../store/dux/soil-sampling-dux';

export function DashboardSubHeader() {
  const stats = useSelector(selectors.stats);

  return (
    stats && (
      <Box data-testid="soil-dashboard-sub-header" sx={{ display: 'flex' }}>
        <Box>
          <FieldSpecialistSelector />
        </Box>
        <Box sx={{ flex: 1 }}>
          <SamplingGoalWidget
            samplingTarget={75000}
            samplingActual={stats.sampledAcres}
          />
        </Box>
      </Box>
    )
  );
}
